import { render, staticRenderFns } from "./UserEmail.vue?vue&type=template&id=5c001c36&scoped=true&"
import script from "./UserEmail.vue?vue&type=script&lang=js&"
export * from "./UserEmail.vue?vue&type=script&lang=js&"
import style0 from "./UserEmail.vue?vue&type=style&index=0&id=5c001c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c001c36",
  null
  
)

export default component.exports